import { request, requestFd } from '@/common/request';
import { clientPrefix, getTokenParams } from '@/config/base';

const prefix = '/hospital';
/**
 * 获取机构信息
 * @param params
 * @returns
 */
export const getImInfo = (params: any) => {
  return request.post<any, any>(`${prefix}/im/getImInfo`, params);
};

export const pageConsultImGroup = (params: any) => {
  return request.post<any, any>(`${prefix}/im/pageConsultImGroup`, params);
};

export const listGroupMsgRecordByMsgDate = (params: any) => {
  return request.post<any, any>(`${prefix}/im/listGroupMsgRecordByMsgDate`, params);
};

export const endConsult = (params: any) => {
  return request.post<any, any>(`${prefix}/im/endConsult`, params);
};

export const startConsult = (params: any) => {
  return request.post<any, any>(`${prefix}/im/startConsult`, params);
};

export const getReportRead = (params: any) => request.post<any, any>('/im/report/read', params);

export default {};
